import { css } from 'lit';
export const timeredCounterStringStyles = css ``;
//# sourceMappingURL=timered-counter-string-styles.js.map